import { ThemeOptions } from "@mui/material/styles";

export const shadows: ThemeOptions["shadows"] = [
    "none",
    "0 1px 12px 0 rgba(0, 0, 0, 0.1)",
    "0 4px 16px 0 rgba(0, 0, 0, 0.12)",
    "0 8px 24px 0 rgba(0, 0, 0, 0.12)",
    "0 8px 24px 0 rgba(0, 0, 0, 0.15)",
    "0 16px 32px 0 rgba(0, 0, 0, 0.15)",
    "0 24px 48px 0 rgba(0, 0, 0, 0.15)",
    "none",
    "none",
    "none",
    "none",
    "none",
    "none",
    "none",
    "none",
    "none",
    "none",
    "none",
    "none",
    "none",
    "none",
    "none",
    "none",
    "none",
    "none",
];

// TODO: rethink this shadow
export const themeShadows = {
    focusVisible: "0 0 0 2px #333333",
};
